import React, { useContext, useEffect, useState, useRef } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { globalFileIcon } from "../../../axiosInstance";
import { ScrollMenu, VisibilityContext } from "react-horizontal-scrolling-menu";
import { setProducts } from "../../server/Product.js";
import {
  getAllCategory,
  getBySlug,
  setCurrentCategoryDispatch,
} from "../../server/Category";
import SubNavbar from "./SubNavbar.js";
import { reloedFunc } from "../../server/Product.js";

const formatCategoryName = (name) => {
  const lines = name.split("|");

  return (
    <span style={{ lineHeight: "1.2" }}>
      {lines.map((line, index) => (
        <span className="nowrap-text" key={index}>
          {line.trim()}
          {index < lines.length - 1 && <br />}
        </span>
      ))}
    </span>
  );
};

const NAVIGATOR = ({ currentSubCategory, setPendingScrollSlug }) => {
  const {
    categories,
    toggleMenu,
    stationId,
    items,
    isClientView,
    includeInactive,
  } = useSelector((state) => ({
    categories: state.category.categories,
    toggleMenu: state.openCart.toggleMenu,
    stationId: state.user.stationId,
    items: state.displayProduct.itemsShow,
    isClientView: state.category.isClientView, 
    includeInactive: state.category.includeInactive, 
  }));
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [children, setChildren] = useState(null);
  const [currentCategory, setCurrentCategory] = useState(null);
  const [activeSlug, setActiveSlug] = useState(null);

  const currentAbortController = useRef(null);

  useEffect(() => {
    if (categories) dispatch(getAllCategory(stationId, null, 5, true, false));
  }, [stationId]);

  useEffect(() => {
    if (pathname.startsWith("/category/")) {
      const splited = pathname.split("/");
      const slug = splited[2];
      setCurrentCategory(slug);
      if (
        currentCategory !== slug &&
        items?.slug !== slug &&
        splited.length === 3
      ) {
        handleCategoryClick(slug);
      }
      const category = categories.find((cat) => cat.slug === slug);
      setChildren(category);
      dispatch(setCurrentCategoryDispatch(category));
    } else {
      setCurrentCategory(null);
      setChildren(null);
    }
  }, [pathname, categories]);

  useEffect(() => {
    if (pathname.startsWith("/category/")) {
      const splited = pathname.split("/");
      const slug = splited[2];
      if (splited.length === 3) {
        handleCategoryClick(slug);
        setCurrentCategory(slug);
      }
    }
  }, [stationId]);


  const isClientViewRef = useRef(isClientView);
  const includeInactiveRef = useRef(includeInactive);

  useEffect(() => {
    isClientViewRef.current = isClientView;
  }, [isClientView]);

  useEffect(() => {
    includeInactiveRef.current = includeInactive;
  }, [includeInactive]);

  const handleCategoryClick = (slug) => {
    setActiveSlug(slug);
    dispatch(setProducts([]));
    dispatch(reloedFunc());
    if (currentAbortController.current) {
      currentAbortController.current.abort();
    }

    const abortController = new AbortController();
    currentAbortController.current = abortController;
    setChildren(null);

    getBySlug(
      stationId,
      slug,
      isClientViewRef.current,
      includeInactiveRef.current,
      {
        signal: abortController.signal,
      },
    )
      .then((res) => {
        if (!abortController.signal.aborted) {
          dispatch(setProducts(res));
        }
      })
      .catch((err) => {
        if (err.name !== "AbortError") console.error(err);
      });
  };

  return (
    <div className="navigator">
      <nav className={toggleMenu ? "active main" : "main"}>
        <ScrollMenu LeftArrow={LeftArrow} RightArrow={RightArrow} RTL>
          <div className="item-sale">
            <img
              loading="lazy"
              src={globalFileIcon + "sale-icon.svg"}
              alt="sale"
            />
            <NavLink
              className={pathname === "/sales" ? "active" : null}
              to="/sales"
            >
              מבצעים
            </NavLink>
          </div>
          {categories &&
            categories.length > 0 &&
            categories
              .filter((cat) => cat.status === "ACTIVE")
              .map((element, index) => (
                <a
                  key={index}
                  className={
                    element.slug === currentCategory ? "item-active" : "item"
                  }
                  onClick={() => navigate(`/category/${element.slug}`)}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      textAlign: "center",
                      width: "100%",
                      height: "100%",
                      cursor: "pointer",
                    }}
                  >
                    {formatCategoryName(element.name)}
                  </div>
                </a>
              ))}
        </ScrollMenu>
      </nav>
      {children?.children && (
        <SubNavbar
          fatherSlug={currentCategory}
          currentSubCategory={currentSubCategory}
          currentCategories={children}
          setPendingScrollSlug={setPendingScrollSlug}
        />
      )}
    </div>
  );
};

const RightArrow = () => {
  const { isFirstItemVisible, scrollPrev } = useContext(VisibilityContext);

  return (
    <button
      disabled={isFirstItemVisible}
      onClick={() => scrollPrev()}
      style={{ height: "60px" }}
    >
      <div className="right-btn">
        <img
          loading="lazy"
          src={globalFileIcon + "open-cart.svg"}
          alt="open-cart"
        />
      </div>
    </button>
  );
};

const LeftArrow = () => {
  const { isLastItemVisible, scrollNext } = useContext(VisibilityContext);

  return (
    <button
      disabled={isLastItemVisible}
      onClick={() => scrollNext()}
      style={{ height: "60px" }}
    >
      <div className="left-btn">
        <img
          loading="lazy"
          src={globalFileIcon + "open-cart.svg"}
          alt="open-cart"
        />
      </div>
    </button>
  );
};

export default NAVIGATOR;
